import ModalBody from '@Components/Feedback/Modal/Body';
import { ModalSize } from "@Components/Feedback/Modal/Frame";
import { useModalContext } from "@Containers/ModalContainer";
import { cloneElement, LazyExoticComponent, ReactElement, ReactNode, Suspense } from "react";

export type ModalContentProps = { closeModal: () => void };

interface ModalProps {
    size?: ModalSize;
    children: ReactElement<any>;
    modalContent?:
        ReactElement
        | (({closeModal}: ModalContentProps) => ReactElement|LazyExoticComponent<any>)
        | LazyExoticComponent<any>
    ;
}

const isLazy = (component: any): component is LazyExoticComponent<any> =>
    component?.$$typeof === Symbol.for('react.lazy');

export default function Modal({
    size = 'md',
    children,
    modalContent,
}: ModalProps) {
    const modal = useModalContext();

    return cloneElement(children, {
        onClick: (event: Event) => {
            event.preventDefault();

            if (typeof children.props.onClick === 'function') {
                children.props.onClick();
            }

            modal.setSize(size);

            let Content: ReactNode|LazyExoticComponent<any>;

            if (typeof modalContent === 'function') {
                Content = modalContent({ closeModal: modal.close });
            } else {
                Content = modalContent;
            }

            if (isLazy(Content)) {
                Content = <Suspense fallback={
                    <ModalBody>
                        <p>Loading...</p>
                    </ModalBody>
                }>
                    <Content />
                </Suspense>;
            }

            modal.open(Content);
        },
    });
}
